__turbopack_context__.v({
  "ant-dropdown-menu": "index-module-scss-module__zxcKOq__ant-dropdown-menu",
  "ant-dropdown-menu-item": "index-module-scss-module__zxcKOq__ant-dropdown-menu-item",
  "ant-dropdown-menu-item-selected": "index-module-scss-module__zxcKOq__ant-dropdown-menu-item-selected",
  "ant-dropdown-menu-title-content": "index-module-scss-module__zxcKOq__ant-dropdown-menu-title-content",
  "back-top-wrap": "index-module-scss-module__zxcKOq__back-top-wrap",
  "card": "index-module-scss-module__zxcKOq__card",
  "cardContent": "index-module-scss-module__zxcKOq__cardContent",
  "cardLink": "index-module-scss-module__zxcKOq__cardLink",
  "cardMeta": "index-module-scss-module__zxcKOq__cardMeta",
  "cardTitle": "index-module-scss-module__zxcKOq__cardTitle",
  "filterTableSelect": "index-module-scss-module__zxcKOq__filterTableSelect",
  "thumbnail": "index-module-scss-module__zxcKOq__thumbnail",
  "thumbnailContainer": "index-module-scss-module__zxcKOq__thumbnailContainer",
  "updateTag": "index-module-scss-module__zxcKOq__updateTag",
});
